import Vue from 'vue'
import Router from 'vue-router'
import home from "@/pages/home"
import about from "@/pages/about"
import service from "@/pages/service"
import product from "@/pages/product"
import contact from "@/pages/contact"
import productDetail from "../pages/product/productDetail";

import mobile from "../pages/mobileIndex"
import mobile_home from "../pages/home/mobile";
import mobile_about from "../pages/about/mobile"
import mobile_contact from "../pages/contact/mobile"
import mobile_service from "../pages/service/mobile"
import mobile_product from "../pages/product/mobile"
import mobileProductDetail from "../pages/product/mobileProductDetail";


Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [{
    path: '/',
    name: "home",
    component: home
  }, {
    path: '/about',
    name: 'about',
    component: about
  }, {
    path: '/service',
    name: 'service',
    component: service
  }, {
    path: '/product',
    name: 'product',
    component: product
  }, {
    path: '/contact',
    name: 'contact',
    component: contact
  },{
    path: '/productDetail',
    name: 'productDetail',
    component: productDetail
  },{
    path: '/mobile',
    name: "mobile",
    component: mobile,
    redirect:'/mobile_home',
    children:[
      {
        path: '/mobile_home',
        name: 'mobile_home',
        component: mobile_home
      },{
        path: '/mobile_about',
        name: 'mobile_about',
        component: mobile_about
      }, {
        path:'/mobile_service',
        name: 'mobile_service',
        component: mobile_service
      },{
        path: '/mobile_product',
        name: 'mobile_product',
        component: mobile_product,
        meta: {
          keepAlive:true
        }
      }, {
        path: '/mobile_contact',
        name: 'mobile_contact',
        component: mobile_contact
      }]
  },{
    path: '/mobileProductDetail',
    name: 'mobileProductDetail',
    component: mobileProductDetail

  }]
})



// WEBPACK FOOTER //
// ./src/router/index.js